














import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-upload',

})
export default class IUpload extends Vue {

  @Prop({type: [String], default: 'all'}) protected count!: string

}

